import _ from 'lodash';
import dynamic from 'next/dynamic';
import { FiArrowRightCircle } from 'react-icons/fi';
import { SHOW_COMMEMORATE } from 'src/constants';
import useResponsive from 'src/utils/devices';

import styled from 'styled-components';

// const CardFull = dynamic(import('src/components/cards/card-full'));
const CardH = dynamic(import('src/components/cards/card-h'));
const CardV = dynamic(import('src/components/cards/card-v'));

const SectionHighlight = ({ data, sectionEventOne, sectionEventOneItem, eventDataLayer }) => {
  if (_.isEmpty(data)) return <div className='default-highlight' />;
  const responsive = useResponsive();

  return (
    <section id='section-2' className='section-highlight' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
      <div className='container'>
        {!responsive.isMobile && (
          <div className='row'>
            <div className='col-lg-7 col-md-12 box-large'>
              {!_.isEmpty(sectionEventOne) ? (
                <SectionEventOne className='sction-event-one' imageBackground={sectionEventOneItem?.item2}>
                  <div className='card-herder'>
                    <img className='card-img-1' src={sectionEventOneItem?.item1} alt='section-event' width='100%' height='100%' />
                    <div className='card-head-title'>
                      <p>{sectionEventOneItem?.item4}</p>
                      <p>{sectionEventOneItem?.item5}</p>
                    </div>
                    {!_.isEmpty(sectionEventOneItem?.item3) ? <img className='card-img-2' src={sectionEventOneItem?.item3} alt='section-event' width='100%' height='100%' /> : null}
                  </div>
                  <div className='card-list'>
                    {sectionEventOne?.data?.map((item, index) => (
                      <div className='card-item'>
                        <CardV
                          index={index}
                          data={item}
                          description={false}
                          badge={false}
                          path={item?.link}
                          //! DATALAYER
                          eventDataLayer={{
                            ...eventDataLayer,
                            data: {
                              ...eventDataLayer?.data,
                              title: item?.title,
                              index: '1'
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  {!_.isEmpty(sectionEventOneItem?.item6) ? (
                    <div className='card-more'>
                      <a href={sectionEventOne?.link || '#'} className='more'>
                        ดูทั้งหมด <FiArrowRightCircle />
                      </a>
                    </div>
                  ) : null}
                </SectionEventOne>
              ) : (
                <>
                  {!_.isEmpty(data[0]) ? (
                    <CardV
                      data={data[0]}
                      description={false}
                      badge={true}
                      path={data[0]?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          ...eventDataLayer?.data,
                          title: data[0]?.title,
                          index: '1'
                        }
                      }}
                    />
                  ) : null}
                </>
              )}
            </div>

            <div className='col-lg-5 col-md-12'>
              <div className='row'>
                <div className='col-6 box-small'>
                  {!_.isEmpty(data[!_.isEmpty(sectionEventOne) ? 0 : 1]) ? (
                    <CardV
                      data={data[!_.isEmpty(sectionEventOne) ? 0 : 1]}
                      description={false}
                      badge={true}
                      path={data[!_.isEmpty(sectionEventOne) ? 0 : 1]?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          ...eventDataLayer?.data,
                          title: data[!_.isEmpty(sectionEventOne) ? 0 : 1]?.title,
                          index: !_.isEmpty(sectionEventOne) ? '1' : '2'
                        }
                      }}
                    />
                  ) : null}
                </div>
                <div className='col-6 box-small'>
                  {!_.isEmpty(data[!_.isEmpty(sectionEventOne) ? 1 : 2]) ? (
                    <CardV
                      data={data[!_.isEmpty(sectionEventOne) ? 1 : 2]}
                      description={false}
                      badge={true}
                      path={data[!_.isEmpty(sectionEventOne) ? 1 : 2]?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          ...eventDataLayer?.data,
                          title: data[!_.isEmpty(sectionEventOne) ? 1 : 2]?.title,
                          index: !_.isEmpty(sectionEventOne) ? '2' : '3'
                        }
                      }}
                    />
                  ) : null}
                </div>

                <div className='col-6 box-small'>
                  {!_.isEmpty(data[!_.isEmpty(sectionEventOne) ? 2 : 3]) ? (
                    <CardV
                      data={data[!_.isEmpty(sectionEventOne) ? 2 : 3]}
                      description={false}
                      badge={true}
                      path={data[!_.isEmpty(sectionEventOne) ? 2 : 3]?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          ...eventDataLayer?.data,
                          title: data[!_.isEmpty(sectionEventOne) ? 2 : 3]?.title,
                          index: !_.isEmpty(sectionEventOne) ? '3' : '4'
                        }
                      }}
                    />
                  ) : null}
                </div>
                <div className='col-6 box-small'>
                  {!_.isEmpty(data[!_.isEmpty(sectionEventOne) ? 3 : 4]) ? (
                    <CardV
                      data={data[!_.isEmpty(sectionEventOne) ? 3 : 4]}
                      description={false}
                      badge={true}
                      path={data[!_.isEmpty(sectionEventOne) ? 3 : 4]?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          ...eventDataLayer?.data,
                          title: data[!_.isEmpty(sectionEventOne) ? 3 : 4]?.title,
                          index: !_.isEmpty(sectionEventOne) ? '4' : '5'
                        }
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* --------------------------------- MOBILE --------------------------------- */}
        {responsive.isMobile && (
          <div className='row block-content'>
            <div className='col-12'>
              {!_.isEmpty(sectionEventOne) ? (
                <SectionEventOne className='sction-event-one' imageBackground={sectionEventOneItem?.item2}>
                  <div className='card-herder'>
                    <img className='card-img-1' src={sectionEventOneItem?.item1} alt='section-event' width='100%' height='100%' />
                    <div className='card-head-title'>
                      <p>{sectionEventOneItem?.item4}</p>
                      <p>{sectionEventOneItem?.item5}</p>
                    </div>
                    {!_.isEmpty(sectionEventOneItem?.item3) ? <img className='card-img-2' src={sectionEventOneItem?.item3} alt='section-event' width='100%' height='100%' /> : null}
                  </div>
                  <div className='card-list'>
                    {sectionEventOne?.data?.map((item, index) => (
                      <div className='card-item'>
                        <CardV
                          index={index}
                          data={item}
                          description={false}
                          badge={false}
                          path={item?.link}
                          //! DATALAYER
                          eventDataLayer={{
                            ...eventDataLayer,
                            data: {
                              ...eventDataLayer?.data,
                              title: item?.title,
                              index: '1'
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  {!_.isEmpty(sectionEventOneItem?.item6) ? (
                    <div className='card-more'>
                      <a href={sectionEventOne?.link || '#'} className='more'>
                        ดูทั้งหมด <FiArrowRightCircle />
                      </a>
                    </div>
                  ) : null}
                </SectionEventOne>
              ) : (
                <>
                  {!_.isEmpty(data[0]) ? (
                    <CardV
                      data={data[0]}
                      description={false}
                      badge={true}
                      path={data[0]?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          ...eventDataLayer?.data,
                          title: data[0]?.title,
                          index: '1'
                        }
                      }}
                    />
                  ) : null}
                </>
              )}
            </div>
            <div className='col-12'>
              <ul className='block-list'>
                {!_.isEmpty(data.slice(!_.isEmpty(sectionEventOne) ? 0 : 1)) &&
                  data.slice(!_.isEmpty(sectionEventOne) ? 0 : 1, !_.isEmpty(sectionEventOne) ? 4 : 5).map((item, index) => (
                    <li key={index}>
                      <CardH
                        data={item}
                        large={false}
                        //! DATALAYER
                        eventDataLayer={{
                          ...eventDataLayer,
                          data: {
                            ...eventDataLayer?.data,
                            title: item?.title,
                            index: index + !_.isEmpty(sectionEventOne) ? 1 : 2
                          }
                        }}
                      />
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionHighlight;

const SectionEventOne = styled.div`
  background-image: url(${props => props.imageBackground});
  background-repeat: repeat;
  background-size: cover;
`;
